import {QuestionBase} from './QuestionBase';

export class RadioQuestion extends QuestionBase<string> {
    controlType = 'radio';
    options: {key: string, value: string}[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}
